import type { SideBySideRow } from "@productlane/lib/src/prosemirror-diff"

export interface DocsChangeLine {
	kind: "added" | "removed"
	text: string
}

/** What the change adds and removes, as plain text; unchanged blocks stay out. */
export function docsChangeLines(
	rows: readonly SideBySideRow[],
): DocsChangeLine[] {
	return rows.flatMap((row): DocsChangeLine[] => {
		const added = row.right?.text.trim()
		const removed = row.left?.text.trim()
		if (row.kind === "insert" || row.kind === "replace") {
			return added ? [{ kind: "added", text: added }] : []
		}
		if (row.kind === "delete") {
			return removed ? [{ kind: "removed", text: removed }] : []
		}
		return []
	})
}

const HEADING = /^\s*<h[1-6][\s>]/i

/** The heading the first change sits under, so the card can say where it goes. */
export function changeSection(rows: readonly SideBySideRow[]): string | null {
	let section: string | null = null
	for (const row of rows) {
		const cell = row.right ?? row.left
		if (row.kind !== "equal") return section
		if (cell && HEADING.test(cell.html)) section = cell.text.trim() || null
	}
	return null
}
